import { useSelector } from 'react-redux';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { StoreUser, User } from '../types/user';

export default function useCurrentUser(): User | null | undefined {
  const uid = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['login', 'uid'], null)) as number || null;
  const user = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['user'], null)) as ImmutableEntity<StoreUser> || null;

  return uid && user ? user.toJS()[uid] : null;
}
